import React, { useEffect, useRef, Fragment } from "react";
import { Link } from "react-router-dom";

import { Container, Row, Col, Button, Card, CardBody } from "reactstrap";

// core components
import GetStarted from "components/Sections/GetStarted";
import AppNavbar from "components/Navbars/AppNavbar";
import Footer from "components/Footers/SimpleFooter";

export default function Features(props) {

    const mainEl = useRef(null);

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainEl.current.scrollTop = 0;

        document.title = "Club Apps | Hello, is anyone listening? Is this thing on?"
        document.querySelector('meta[name="description"]').setAttribute("content", "Club Apps offers several ways to get in touch and start a conversation.If you prefer to reach out directly, please contact us at info@clubapps.org.");
    }, []);

    return (
        <Fragment>
            <AppNavbar white />
            <main ref={mainEl}>
                <section className="section sales-index-section">
                    <div className="sales-index-background-container"/>
                    <Container className="pt-4 pb-5 pb-lg-8 text-center">
                        <Row className="justify-content-center">
                            <Col md="6">
                                <h1 className="display-3">
                                    Contact Us
                                </h1>
                                <h4 className="text-muted">
                                    We offer several ways to get in touch and start a conversation.
                                </h4>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-secondary"
                                points="2560 0 2560 100 0 100"
                            />
                        </svg>
                    </div>
                </section>
                <section className="section bg-secondary">
                    <Container className="pb-5">
                        <Row className="row-grid">
                            <Col lg="6">
                                <Card className="card-form shadow shadow-lg--hover mt--150">
                                    <CardBody className="py-5">
                                        <div className="icon icon-shape icon-shape-success rounded-circle mb-4">
                                            <i className="ni ni-single-02" />
                                        </div>
                                        <h5 className="text-success text-uppercase">
                                            Sales Team
                                        </h5>
                                        <p className="lead">
                                            Get in touch with our sales team to find out how Club Apps can help elevate your membership.
                                        </p>
                                        <Button
                                            className="mt-4"
                                            outline
                                            color="success"
                                            to="/contact/sales"
                                            tag={Link}
                                            >
                                            Contact Sales
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="6">
                                <Card className="card-form shadow shadow-lg--hover mt--150">
                                    <CardBody className="py-5">
                                        <div className="icon icon-shape icon-shape-warning rounded-circle mb-4">
                                            <i className="ni ni-support-16" />
                                        </div>
                                        <h5 className="text-warning text-uppercase">
                                            Technical or Account Support
                                        </h5>
                                        <p className="lead">
                                            Visit our support center to find an answer to a topic, or get in touch with our support team.
                                        </p>
                                        <Button
                                            className="mt-4"
                                            outline
                                            color="warning"
                                            to="/features"
                                            tag={Link}
                                            >
                                            Visit Support
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                    <div className="separator separator-bottom separator-skew zindex-100">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                            >
                            <polygon
                                className="fill-white"
                                points="2560 0 2560 100 0 100"
                            />
                        </svg>
                    </div>
                </section>
                <section className="section">
                    <Container>
                        <Row className="justify-content-center text-center">
                            <Col md="6">
                                <h3 className="display-4">
                                    Looking for another way to contact us?
                                </h3>
                                <p className="lead">
                                    For general inquiries and comments, please message us at <a href="mailto:info@clubapps.org">info@clubapps.org</a> or give us a call at <a href="tel:(210) 265-6500">(210) 265-6500</a>.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </main>
            <Footer/>
        </Fragment>
    );
}
